import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';

import type { TypeCtaSkeleton } from './TypeCta';

export interface TypeBlockCtaFields {
    internalName: EntryFieldTypes.Symbol;
    title?: EntryFieldTypes.Symbol;
    description?: EntryFieldTypes.RichText;
    cta: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeCtaSkeleton>>;
    displayOption?: EntryFieldTypes.Symbol<'centered'>;
}

export type TypeBlockCtaSkeleton = EntrySkeletonType<TypeBlockCtaFields, 'blockCta'>;
export type TypeBlockCta<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlockCtaSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlockCta<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: unknown,
): entry is TypeBlockCta<Modifiers, Locales> {
    const candidate = entry as { sys?: { contentType?: { sys?: { id?: string } } } };

    return candidate.sys?.contentType?.sys?.id === 'blockCta';
}
